export default async function ({ app, $fire, store }) {
  if (process.server) {
    try {
      let token = app.$cookies.get('customToken')
      if (token) {
        await $fire.auth.signInWithCustomToken(token)
        store.commit('firebase/setToken', {
          token
        })
      }
    } catch (error) {
      console.error(error.message)
    }
  }

  // customToken
}
